import React from 'react';

const Banner = ({ children, className }) => (
  <div className={`px-4 py-3 shadow ${className || 'bg-gray-200'}`}>
    {children}
  </div>
);

export default Banner;
